import { a as l } from "./index777.mjs";
import { i as n } from "./index815.mjs";
var i = l, d = n, t = function(r, e) {
  var a = r[e];
  return d(a) ? void 0 : i(a);
};
export {
  t as g
};
